import { render, staticRenderFns } from "./VarietyList.vue?vue&type=template&id=522159ac&scoped=true"
import script from "./VarietyList.vue?vue&type=script&lang=js"
export * from "./VarietyList.vue?vue&type=script&lang=js"
import style0 from "./VarietyList.vue?vue&type=style&index=0&id=522159ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522159ac",
  null
  
)

export default component.exports